import styled from 'styled-components';

export const RegisterTypeStoreContainerStyled = styled.div`
  .regis_type_title {
    margin-bottom: 16px;
  }
`;
